import { render, staticRenderFns } from "./ActivosTab.vue?vue&type=template&id=feaadd66&scoped=true"
import script from "./ActivosTab.vue?vue&type=script&lang=js"
export * from "./ActivosTab.vue?vue&type=script&lang=js"
import style0 from "./ActivosTab.vue?vue&type=style&index=0&id=feaadd66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaadd66",
  null
  
)

export default component.exports